import { Col, Form, Row } from "antd";
import React, { useMemo } from "react";

import { SupportedControls } from "../../molecules";

export const ModalForm: React.FC<{
  controls: any;
  hardcodedControls: any;
}> = ({ controls, hardcodedControls }) => {
  // Collect all child UUIDs from field-group controls
  const childUuids = useMemo(() => {
    const uuids = new Set<string>();
    controls.forEach((control: any) => {
      if (control.field_type === "field-group" && Array.isArray(control.children)) {
        control.children.forEach((uuid: string) => uuids.add(uuid));
      }
    });
    return uuids;
  }, [controls]);

  // Filter out controls that are children of a field-group
  const visibleControls = useMemo(() => {
    return controls.filter((control: any) => !childUuids.has(control.uuid));
  }, [controls, childUuids]);

  return (
    <Form layout="vertical">
      <Row gutter={16}>
        {[...hardcodedControls]
          .sort((a: any, b: any) => {
            return a.position - b.position;
          })
          .map((control: any) => {
            return (
              <Col span={control.displaying_size} key={control.uuid}>
                <SupportedControls control={control} allControls={controls} />
              </Col>
            );
          })}
        {[...visibleControls]
          .sort((a: any, b: any) => {
            return a.position - b.position;
          })
          .map((control: any) => {
            return (
              <Col span={control.displaying_size} key={control.uuid}>
                <SupportedControls control={control} allControls={controls} />
              </Col>
            );
          })}
      </Row>
    </Form>
  );
};
